var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnonymousAvatarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#163438"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 44,
    r: 20,
    fill: "#eff8f4ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 102c0-17.673 14.327-32 32-32s32 14.327 32 32v2H32v-2z",
    fill: "#eff8f4ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymousAvatarLogo);
export default __webpack_public_path__ + "static/media/anonymous_avatar_logo.20388b3d0e546574046213bfeaaa87a6.svg";
export { ForwardRef as ReactComponent };